import React, { Component } from 'react';
import { connect } from 'react-redux'
import * as actionCreator from '../../../redux/actions/data-action';
import { AssessmentBody, AssessmentResponse } from '../common';
import { taskType, subTaskType, getTasks } from '../common/task-utility';
import createTask from '../tasks/tasks';

class TaskVerbal extends Component {
	render() {
		const { task, selectResponse } = this.props;

		return (
			<AssessmentBody>
				<AssessmentResponse
					className="verbal-response"
					type={task.taskType}
					options={task.options}
					selected={task.response}
					onSelect={selectResponse} />
			</AssessmentBody>
		);
	}
}

const mapStateToProps = state => ({
	tasks : getTasks(state.data.tasks, taskType.ITEMLIST, subTaskType.TASKS),
	taskType: taskType.ITEMLIST,
	subTaskType: subTaskType.TASKS,
});

const classNames = {
	container: 'task-container verbal-container',
	header: 'verbal-header',
	navigation: 'verbal-navigation'
};

export default connect(
	mapStateToProps,
	Object.assign({}, actionCreator)
)(createTask(TaskVerbal, classNames));